<template>
  <div class="wrapper">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <notifications></notifications>
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"></div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section pb-0">
        <div class="container">
          <h3 class="card-title">{{labels.ordering}}</h3>
          <br />
          <ValidationObserver v-slot="{ isvalid }" ref="observer">
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <h4>{{labels.personalinfo}}</h4>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider name="Name" rules="required" v-slot="{ passed, failed }">
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.customername}}</label>
                        <md-input v-model="draft.customername" key="input1"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider
                      name="Phone"
                      :rules="{ required: true, regex: /^[0-9]+$/, min: 9 }"
                      v-slot="{ passed, failed }"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.phone}} ({{labels.example.toLowerCase()}} 994501234567 )</label>
                        <md-input v-model="draft.phone" key="input2"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider
                      name="Email"
                      rules="required|email"
                      v-slot="{ passed, failed }"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.email}}</label>
                        <md-input v-model="draft.email" key="input3"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                </div>
                <h4>{{labels.paytype}}</h4>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-radio
                      key="r1"
                      v-model="draft.paytype"
                      :value="1"
                      v-if="info.paymentonline"
                    >{{labels.payonline}}</md-radio>
                    <br v-if="info.paymentpos" />
                    <md-radio
                      key="r2"
                      v-model="draft.paytype"
                      :value="2"
                      v-if="info.paymentpos"
                    >{{labels.paybycard}}</md-radio>
                    <br />
                    <md-radio key="r3" v-model="draft.paytype" :value="3">{{labels.paycash}}</md-radio>
                    <br />

                    <md-field v-if="draft.paytype===3">
                      <label>{{labels.change}}</label>
                      <md-input v-model="draft.changefrom" type="number"></md-input>
                    </md-field>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-67">
                <h4>{{labels.deliverytype}}</h4>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-radio
                      key="r4"
                      v-model="draft.deliverytype"
                      :value="1"
                      v-if="info.delivery"
                    >{{labels.dlvrcourier}}</md-radio>
                    <md-radio key="r6" v-model="draft.deliverytype" :value="2">{{labels.dlvrpickup}}</md-radio>
                    <md-radio
                      key="r5"
                      v-model="draft.deliverytype"
                      :value="3"
                      v-if="info.activity === '1'"
                    >{{labels.dlvrimhere}}</md-radio>
                  </div>
                </div>
                <div class="md-layout" v-if="info.delivery & draft.deliverytype === 1">
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider name="Street" rules="required" v-slot="{ passed, failed }">
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.street}}</label>
                        <md-input v-model="draft.street" key="inout4"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-60 md-small-size-100">
                    <ValidationProvider name="House" rules="required" v-slot="{ passed, failed }">
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.house}}</label>
                        <md-input v-model="draft.house" key="inout5"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field>
                      <label>{{labels.entrance}}</label>
                      <md-input v-model="draft.entrance" key="inout6"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field>
                      <label>{{labels.entrancecode}}</label>
                      <md-input v-model="draft.entrancecode" key="inout7"></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-50">
                    <ValidationProvider name="Floor" rules="required" v-slot="{ passed, failed }">
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.floor}}</label>
                        <md-input v-model="draft.floor" type="number" key="inout8"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <ValidationProvider
                      name="Flat or Office"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.flatoffice}}</label>
                        <md-input v-model="draft.flat" key="inout9"></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>{{labels.addressnote}}</label>
                      <md-input v-model="draft.addressnotes" key="inout10"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30 md-small-size-100">
                    <md-button class="md-simple md-close md-round md-success" @click="onShowMap(2)">
                      <md-icon>location_on</md-icon>
                      {{labels.showonmap}}
                    </md-button>
                  </div>
                  <div class="md-layout-item md-size-70 md-small-size-100">
                    <span
                      class="span-format"
                    >{{labels.selectedloc}}: {{!acoord.empty ? acoord.lat + ", " + acoord.lng : "None"}}</span>
                    <md-button
                      class="md-just-icon md-simple md-round md-danger"
                      @click="acoord = {lat: '', lng: '', empty: true}"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                </div>
                <div class="md-layout" v-if="draft.deliverytype === 2">
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider name="Floor" rules="required" v-slot="{ passed, failed }">
                      <el-select
                        no-data-text="No data"
                        loading-text="Loading"
                        :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                        v-model="draft.locationid"
                        placeholder="Select"
                        @change="locChange"
                      >
                        <el-option
                          v-for="l in loc"
                          :key="l.id"
                          :label="l.name + ' (' + l.address + ')'"
                          :value="l.id"
                        ></el-option>
                      </el-select>
                    </ValidationProvider>
                  </div>
                  <div class="md-layout-item md-size-40 md-small-size-50">
                    <span
                      v-if="coord.lat"
                      class="span-format"
                    >{{labels.wtime}}: {{open.from}} - {{open.to}}, {{labels.phone}}: {{open.phone}}</span>
                  </div>
                  <div class="md-layout-item md-size-60 md-small-size-50">
                    <md-button
                      v-if="coord.lat"
                      class="md-simple md-close md-round md-success"
                      @click="onShowMap(1)"
                    >
                      <md-icon>location_on</md-icon>
                      {{labels.showonmap}}
                    </md-button>
                  </div>
                </div>
                <div class="md-layout" v-if="draft.deliverytype === 3">
                  <div class="md-layout-item md-size-100">
                    <ValidationProvider
                      name="Table number"
                      rules="minmax:1,99"
                      v-slot="{ passed, failed }"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <label>{{labels.tablenumber}}</label>
                        <md-input
                          key="inout11"
                          v-model="draft.tablenumber"
                          min="1"
                          max="99"
                          type="number"
                        ></md-input>
                      </md-field>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <h4>{{labels.deliverytime}}</h4>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-30 md-small-size-100">
                        <md-radio
                          key="r7"
                          v-model="draft.deliverytimetype"
                          :value="1"
                        >{{labels.now}}</md-radio>
                        <md-radio
                          key="r8"
                          v-model="draft.deliverytimetype"
                          :value="2"
                        >{{labels.later}}</md-radio>
                      </div>
                      <div class="md-layout-item md-size-30 md-small-size-100">
                        <el-select
                          key="s1"
                          filterable
                          v-if="draft.deliverytimetype===2"
                          v-model="draft.deliverytime"
                          :placeholder="labels.select"
                        >
                          <el-option
                            v-for="time in deliveryTime(info.deliverytimefrom,info.deliverytimeto)"
                            :key="time"
                            :label="time"
                            :value="time"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-60 md-small-size-100">
                    <div>
                      <h4 class="title" style="text-align: center">{{labels.totalorderprice}}</h4>
                      <div style="text-align: center; padding-bottom: 10px">
                      <span style="font-size: 22px; font-weight: 400" class="price price-new">₼ {{order.total}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-60 md-small-size-100 text-center">
                    <md-button
                      @click="$router.push({path: '/cart/' + id })"
                      class="md-simple md-success"
                    >{{labels.backtocart}}</md-button>
                    <md-button
                      class="md-round md-primary"
                      @click.prevent="onSave(isvalid)"
                    >{{labels.finishorder}}</md-button>
                  </div>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showMessage" width="100%" :center="true" :before-close="onClose">
      <div style="text-align: center">
        <h2>{{labels.ordersent}}</h2>
        <h3 class="title">{{labels.ordernumber}}: {{ordernumber}}</h3>
        <md-button class="md-success md-round" @click="onClose">{{labels.close}}</md-button>
      </div>
    </el-dialog>

    <el-dialog
      name="d1"
      :visible.sync="mapLoc"
      width="70%"
      :center="true"
      :destroy-on-close="false"
      @opened="onOpen"
    >
      <Map name="m1" :moveto="coord" :selectable="false" ref="filtermap" />
    </el-dialog>

    <el-dialog
      name="d2"
      :visible.sync="mapAddress"
      width="70%"
      :center="true"
      :destroy-on-close="false"
      @opened="onOpenAddress"
    >
      <Map name="m2" @location-marked="locationMarked" ref="addressmap" :moveto="acoord" />
      <div class="md-layout">
        <div class="md-layout-item md-size-100" style="text-align: center">
          <md-button class="md-danger md-simple md-lg" @click="mapAddress = false">{{labels.close}}</md-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Map from "./Map";
import { Modal } from "@/components";
import { mapState } from "vuex";
import Mixins from "@/plugins/basicMixins";
import { fileUrl, nophoto, Round2, DeliveryTime } from "../services/helper";
import { LoadCookie, SetCookie } from "../services/localstate";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  validate
} from "vee-validate/dist/vee-validate.full";
import { CreateOrder } from "../services/share";
import { Select, Option, Dialog } from "element-ui";
extend("minmax", {
  validate(value, { min, max }) {
    return Number(value) >= Number(min) && Number(value) <= Number(max);
  },
  params: ["min", "max"]
});

export default {
  props: { id: String },
  components: {
    Loading,
    ValidationObserver,
    ValidationProvider,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    Map
  },
  mixins: [Mixins.HeaderImage],

  data() {
    return {
      mapLoc: false,
      mapAddress: false,
      coord: {
        empty: true,
        lat: "",
        lng: ""
      },
      acoord: { lat: "", lng: "", empty: true },
      open: { from: "", to: "" },
      nophoto: nophoto,
      ordernumber: "",
      showMessage: false,
      isLoading: false,
      labels: {
        customername: this.localeLabel("customername"),
        phone: this.localeLabel("phone"),
        email: this.localeLabel("email"),
        count: this.localeLabel("count"),
        amount: this.localeLabel("amount"),
        continueshop: this.localeLabel("continueshop"),
        gotobasket: this.localeLabel("gotobasket"),
        shopcart: this.localeLabel("shopcart"),
        finish: this.localeLabel("finish"),
        payonline: this.localeLabel("payonline"),
        paycash: this.localeLabel("paycash"),
        paybycard: this.localeLabel("paybycard"),
        personalinfo: this.localeLabel("personalinfo"),
        paytype: this.localeLabel("paytype"),
        change: this.localeLabel("change"),
        deliverytype: this.localeLabel("deliverytype"),
        deliverytime: this.localeLabel("deliverytime"),
        dlvrcourier: this.localeLabel("dlvrcourier"),
        dlvrpickup: this.localeLabel("dlvrpickup"),
        dlvrimhere: this.localeLabel("dlvrimhere"),
        now: this.localeLabel("now"),
        later: this.localeLabel("later"),
        street: this.localeLabel("street"),
        entrance: this.localeLabel("entrance"),
        entrancecode: this.localeLabel("entrancecode"),
        floor: this.localeLabel("floor"),
        house: this.localeLabel("house"),
        flatoffice: this.localeLabel("flatoffice"),
        addressnote: this.localeLabel("addressnote"),
        tablenumber: this.localeLabel("tablenumber"),
        totalorderprice: this.localeLabel("totalorderprice"),
        backtocart: this.localeLabel("backtocart"),
        finishorder: this.localeLabel("finishorder"),
        ordering: this.localeLabel("ordering"),
        fillrequireds: this.localeLabel("fillrequireds"),
        select: this.localeLabel("select"),
        ordersent: this.localeLabel("ordersent"),
        ordernumber: this.localeLabel("ordernumber"),
        close: this.localeLabel("close"),
        example: this.localeLabel("example"),
        showonmap: this.localeLabel("showonmap"),
        selectedloc: this.localeLabel("selectedloc"),
        wtime: this.localeLabel("wtime")
      },
      draft: {
        id: "",
        shareid: this.id,
        customerName: "",
        phone: "",
        email: "",
        tablenumber: 0,
        addressnotes: "",
        street: "",
        entrance: "",
        entrancecode: "",
        flat: "",
        floor: 1,
        house: "",
        latlng: "",
        changefrom: 0,
        paytype: 0,
        deliverytype: 0,
        deliverytimetype: 1,
        deliverysum: 0,
        deliverytime: "",
        locationid: "",
        location: "",
        details: []
      }
    };
  },
  methods: {
    locationMarked(lat, lng) {
      this.acoord.lat = lat;
      this.acoord.lng = lng;
      this.acoord.empty = false;
    },
    deliveryTime(from, to) {
      if (from === undefined) return;
      if (this.draft.deliverytimetype === 2) return DeliveryTime(from, to);
    },
    onSave(isvalid) {
      this.$refs.observer.validate().then(isvalid => {
        if (!isvalid) alert(this.labels.fillrequireds);
        else {
          this.isLoading = true;
          if (this.draft.locationid) {
            let sl = this.loc.filter(c => c.id === this.draft.locationid)[0];
            this.draft.location = sl.name + " (" + sl.address + ")";
          }
          this.draft.lat = this.acoord.empty ? "" : this.acoord.lat;
          this.draft.lng = this.acoord.empty ? "" : this.acoord.lng;
          CreateOrder(this.draft).then(response => {
            this.isLoading = false;
            if (response.data.result) {
              this.ordernumber = response.data.result.ordernumber.padStart(
                4,
                "0"
              );
              this.showMessage = true;
              this.$store.dispatch("clearCart", this.id);
              this.SetPersonalInfo();
            }
          });
        }
      });
    },
    
    onClose() {
      this.showMessage = false;
      this.$router.push({ path: "/m/" + this.id });
    },
    locChange() {
      let item = this.loc.filter(c => c.id === this.draft.locationid)[0];
      this.coord = { id: item.id, lat: item.lat, lng: item.lng };
      this.open = { from: item.openfrom, to: item.opento, phone: item.phone };
    },
    onShowMap(i) {
      if (i === 1) this.mapLoc = true;
      else {
        if (!this.acoord.lat)
          this.acoord = {
            lat: "40.385238",
            lng: "49.8215883",
            empty: true
          };
        this.mapAddress = true;
      }
    },
    onOpen() {
      this.$refs.filtermap.setMapPosition();
    },
    onOpenAddress() {
      this.$refs.addressmap.setMapPosition();
    },
    SetPersonalInfo() {
      SetCookie(
        "_cinfo",
        JSON.stringify({
          customername: this.draft.customername,
          phone: this.draft.phone,
          email: this.draft.email,
          street: this.draft.street,
          house: this.draft.house,
          entrance: this.draft.entrance,
          entrancecode: this.draft.entrancecode,
          floor: this.draft.floor,
          flat: this.draft.flat,
          lat: this.draft.lat,
          lng: this.draft.lng,
          notes: this.draft.addressnotes
        })
      );
    },
    LoadPersonalInfo() {
      let info = LoadCookie("_cinfo");
      if (!info) return;
      this.draft.customername = info.customername;
      this.draft.phone = info.phone;
      this.draft.email = info.email;

      this.draft.street = info.street;
      this.draft.house = info.house;
      this.draft.entrance = info.entrance;
      this.draft.entrancecode = info.entrancecode;
      this.draft.floor = info.floor;
      this.draft.flat = info.flat;
      this.draft.addressnotes = info.notes;

      this.acoord.lat = info.lat;
      this.acoord.lng = info.lng;
      this.acoord.empty = false;
    }
  },
  mounted() {
    if (this.order.total === 0) this.$router.push({ path: "/m/" + this.id });
    this.draft.paytype = this.info.paymenttype;
    this.draft.deliverytype = this.info.deliverytype;
    this.draft.details = this.order.details;
    this.draft.company = this.info.company;
    this.draft.companyemail = this.info.email;

    this.LoadPersonalInfo();
  },
  created() {
    this.$store.dispatch("fetchMenuBkg", this.id);
    this.$store.dispatch("fetchLocations", this.id);
  },
  computed: {
    ...mapState({
      order: state => state.order,
      info: state => state.info,
      bkg: state => state.menubkg,
      loc: state => state.loc
    }),
    fileurl() {
      return fileUrl;
    },
    image() {
      return this.bkg ? this.fileurl + this.bkg : "";
    }
  }
};
</script>

<style lang="scss">
.text-center {
  text-align: center;
}
.el-select {
  display: block;
  width: "100%";
}
.span-format {
  display: inline-block;
  padding-top: 13px;
  font-size: 12px;
}
</style>
